import { EducationModule } from "@js/components/EducationCourse/eduConfig";
import { level1ModuleCompleteColor } from "@js/educationContent/CairoMummiesContent/eduConstants";
import Ribbon0 from "@js/public/images/Ribbon0.svg";
import StarklingsLogo from "@js/public/images/StarklingsLogo.svg";
import {
    lesson0DefaultEndCode,
    lesson0DefaultMiddleCode,
    lesson0DefaultStartCode,
} from "./lesson0";
import {
    lesson1DefaultEndCode,
    lesson1DefaultMiddleCode,
    lesson1DefaultStartCode,
} from "./lesson1";
import {
    lesson2DefaultEndCode,
    lesson2DefaultMiddleCode,
    lesson2DefaultStartCode,
} from "./lesson2";
import { m7l0Solution } from "./lesson0Solution";
import { m7l1Solution } from "./lesson1Solution";
import { m7l2Solution } from "./lesson2Solution";

export const starklings1EnumsConfig: EducationModule = {
    solution: "",
    imgSrc: StarklingsLogo.src,
    moduleInfo: {
        id: 7,
        moduleName: "starklings1Enums",
        timeEstimate: "20-30 min",
        title: "Starklings 1.0  Enums",
        description: `Welcome to the intro of Starklings 1.0 Enums lessons. Good luck!`,
        moduleComplete: {
            badgeName: "STARKLINGS 1.0 ENUMS",
            badgeCaption: "A level 1 Starkling 1.0",
            ribbonImgSrc: Ribbon0.src,
            badgeImgSrc: StarklingsLogo.src,
            imgColor: level1ModuleCompleteColor,
            badgeTokenId: 20,
        },
    },
    lessons: [
        {
            timeEstimate: "5 min",
            title: "Enums00",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Cairo allows you to define types called enums which enumerate possible values. Enums are a feature in many languages, but their capabilities differ in each language. Cairo's enums are most similar to Rust and algebraic data types in functional languages. Useful in combination with enums is Cairo's 'pattern matching' facility, which makes it easy to run different code for different values of an enumeration." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch05-01-enums.html", "children": [ { "text": "Enums" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson0DefaultStartCode,
            defaultMiddleCode: lesson0DefaultMiddleCode,
            defaultEndCode: lesson0DefaultEndCode,
            id: 0,
            solution: m7l0Solution,
        },
        //         {
        //             timeEstimate: "5 min",
        //             title: "Enums01",
        //             formattedDescription: `
        // [ { "type": "paragraph", "children": [ { "text": "Cairo allows you to define types called enums which enumerate possible values. Enums are a feature in many languages, but their capabilities differ in each language. Cairo's enums are most similar to Rust and algebraic data types in functional languages. Useful in combination with enums is Cairo's 'pattern matching' facility, which makes it easy to run different code for different values of an enumeration." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch05-01-enums.html", "children": [ { "text": "Enums" } ] }, { "text": "" } ] } ] } ]
        //         `,
        //             hints: [],
        //             defaultStartCode: lesson1DefaultStartCode,
        //             defaultEndCode: lesson1DefaultEndCode,
        //             defaultMiddleCode: lesson1DefaultMiddleCode,
        //             id: 1,
        //             solution: m7l1Solution,
        //         },
        {
            timeEstimate: "15 min",
            title: "Enums02",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Cairo allows you to define types called enums which enumerate possible values. Enums are a feature in many languages, but their capabilities differ in each language. Cairo's enums are most similar to Rust and algebraic data types in functional languages. Useful in combination with enums is Cairo's 'pattern matching' facility, which makes it easy to run different code for different values of an enumeration." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch05-01-enums.html", "children": [ { "text": "Enums" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson2DefaultStartCode,
            defaultMiddleCode: lesson2DefaultMiddleCode,
            defaultEndCode: lesson2DefaultEndCode,
            id: 1,
            solution: m7l2Solution,
        },
    ],
};
